import { chain, map } from 'fp-ts/lib/TaskEither';
import { flow, pipe } from 'fp-ts/lib/function';
import { detailCodec, listCodec } from './codec';
import {
  createAuthorizedGetRequest,
  decode,
  fetchApi,
  setQuery,
} from '@/services/api';
import { encodeAiPhotoValidationQuery, AiPhotoValidationListParams } from './query';

const baseUrl = '/v2/ai-photo-validations';
const recordUrl = (id: number): string => `${baseUrl}/${id}`;

export const list = (params: AiPhotoValidationListParams) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeAiPhotoValidationQuery(params))),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(detailCodec)),
);
